/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import metadata from './RoofsAndAdditionAccordion.metadata.json5';
import styles from './RoofsAndAdditionAccordion.module.scss'

const RoofsAndAdditionAccordion = props => {
    const {
        roofAndRepairs
    } = props;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        roofandRepairsTable: {
            data: roofAndRepairs
        },

    };


    const resolvers = {
        resolveClassNameMap: styles
    };


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={roofAndRepairs}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
};


RoofsAndAdditionAccordion.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({})
};
export default RoofsAndAdditionAccordion;
